export default __webpack_public_path__ + "static/media/linkedinphoto.0ec6a2bf.png";